import { Component, Input } from "@angular/core";
import { Align } from "@tylertech/tyler-api-types";
import { MetadataTextButtonComponent } from "./metadata-text-button.component";
import { LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { NgClass } from "@angular/common";
import { ClassDirective } from "@ngbracket/ngx-layout/extended";
import { ForgeFocusIndicatorModule } from "@tylertech/forge-angular";

@Component({
    selector: "metadata-link",
    templateUrl: "./metadata-link.tmpl.html",
    imports: [
        ClassDirective,
        LayoutDirective,
        ForgeFocusIndicatorModule,
        NgClass,
    ]
})
export class MetadataLinkComponent extends MetadataTextButtonComponent
{
    get layout(): string
    {
        switch (this.propertyMetadata.Alignment)
        {
            case Align.Right:
                return "layout-end";

            case Align.Center:
                return "layout-center";

            case Align.Left:
            default:
                return "layout-start";
        }
    }

    get id(): string
    {
        return `link-${this.propertyMetadata.Name}`;
    }
}
